import { render, staticRenderFns } from "./Brisbane.vue?vue&type=template&id=be137784&scoped=true"
import script from "./Brisbane.vue?vue&type=script&lang=js"
export * from "./Brisbane.vue?vue&type=script&lang=js"
import style0 from "./Brisbane.vue?vue&type=style&index=0&id=be137784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be137784",
  null
  
)

export default component.exports